/**
 * Preferencias de interface do usuario, persistidas em localStorage.
 *
 * Diferente de token/user/permissions, estas preferencias NAO sao limpas
 * no logout (ver logout.vue e routes.js) - so se perdem ao trocar de
 * navegador. Ficam todas sob uma unica chave (objeto JSON), pensando em
 * novas preferencias de outras paginas no futuro.
 */
export const CHAVE_PREFERENCIAS = 'preferencias'

function getPreferencias() {
    try {
        const dados = window.localStorage.getItem(CHAVE_PREFERENCIAS)
        return dados ? JSON.parse(dados) : {}
    } catch (e) {
        return {}
    }
}

function setPreferencias(prefs) {
    window.localStorage.setItem(CHAVE_PREFERENCIAS, JSON.stringify(prefs))
}

/**
 * Modo de visualizacao de listagens: 'lista' (default) ou 'grade'.
 */
export function getVisualizacao() {
    return getPreferencias().visualizacao || 'lista'
}

export function setVisualizacao(modo) {
    const prefs = getPreferencias()
    prefs.visualizacao = modo
    setPreferencias(prefs)
}

/**
 * Estado do menu lateral (sidebar) colapsado/minimizado: true ou false (default).
 */
export function getMenuColapsado() {
    return getPreferencias().menuColapsado === true
}

export function setMenuColapsado(colapsado) {
    const prefs = getPreferencias()
    prefs.menuColapsado = colapsado
    setPreferencias(prefs)
}
